import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UpdateRodRequestErrorProps } from './types';
import { UpdateRodRequestErrorCode } from '@bechtel/types';

const getErrorMessage = (error: UpdateRodRequestErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateRodRequestErrorCode.COMMENT_TOO_LARGE:
      return <Trans>Comment is too large.</Trans>;
    case UpdateRodRequestErrorCode.WELD_PROCEDURE_NOT_APPLICABLE:
      return <Trans>Weld procedure is not applicable.</Trans>;
    case UpdateRodRequestErrorCode.INVALID_ROD_REQUEST_ID:
      return <Trans>Invalid Rod Request Number.</Trans>;
    case UpdateRodRequestErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>You do not have permission to update rod request.</Trans>;
    case UpdateRodRequestErrorCode.INVALID_ROD_ROOM_ID:
      return <Trans>Invalid Rod Room.</Trans>;
    case UpdateRodRequestErrorCode.ROD_REQUEST_ALREADY_CLOSED:
      return <Trans>Rod Request is already closed.</Trans>;
    case UpdateRodRequestErrorCode.ROD_REQUEST_ALREADY_DELETED:
      return <Trans>Rod Request is already deleted.</Trans>;
    case UpdateRodRequestErrorCode.UPDATE_ROD_REQUEST_ERRORED:
      return <Trans>Some error has occured. Please try again after sometime</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const UpdateRodRequestError: FC<UpdateRodRequestErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Rod Request Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
